import { rootURL } from '../constants';

function request({method,url,data,headers}){
    return new Promise( (resolve,reject) => {
        var xhr = new XMLHttpRequest();
        xhr.onload = function(){
            if (xhr.status >= 200 && xhr.status < 300) {
                resolve(response());
            } else {
                error();
            }            
        }
        xhr.onerror = xhr.onabort = error;
        function error(){
            reject(response() || {ExceptionMessage:'Cannot connect to server, please try again in a few minutes.'});
        }
        function response(){
            return typeof xhr.response === 'string' ? JSON.parse(xhr.response) : xhr.response;
        }
        xhr.open(method, 
            (url.indexOf('.json') === -1 && url.indexOf('https://') === -1 && url.indexOf('localhost') === -1 ? rootURL : '') + 
            url + 
            (method === 'GET' && !!data ? '?' + Object.keys(data).map(key => `${key}=${encodeURIComponent(data[key])}`).join('&') : '')
        );
        xhr.setRequestHeader('Accept', 'application/json, text/plain, */*');        
        if (headers)
            for (let x in headers)
                xhr.setRequestHeader(x, headers[x]);

        if(method === 'POST'){
            xhr.setRequestHeader('Content-Type','application/x-www-form-urlencoded; charset=UTF-8');
        }
        
        xhr.responseType = 'json';
        xhr.send(data ? method === 'POST' ? data : JSON.stringify(data) : undefined);    
    });
}

function getScript(source){
    return new Promise(resolve => {
        const script = document.createElement('script');
        script.async = true;

        script.onload = script.onreadystatechange = (_, isAbort) => {
            if (isAbort || !script.readyState || /loaded|complete/.test(script.readyState)) {
                script.onload = script.onreadystatechange = null;
                script.remove();
                if (!isAbort) resolve();
            }
        };
        script.src = source;
        document.head.appendChild(script);    
    });
    
};

function http(url){
    return {
        get(data){
            return request({method:'GET',url,data});
        },
        create(data, headers) {
            if (typeof data === 'object') {
                data = (new URLSearchParams(data)).toString()
            }
            return request({method:'POST',url,data,headers});
        },
        script(){
            return getScript(url);
        }
    };
}

export default http;